import _export from '../internals/export.js';
import descriptors from '../internals/descriptors.js';
import '../internals/object-define-property.js';
import { __exports as objectDefineProperty } from '../../../../../../_virtual/object-define-property.js';

var $ = _export;
var DESCRIPTORS = descriptors;
var defineProperty = objectDefineProperty.f; // `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
// eslint-disable-next-line es/no-object-defineproperty -- safe

$({
  target: 'Object',
  stat: true,
  forced: Object.defineProperty !== defineProperty,
  sham: !DESCRIPTORS
}, {
  defineProperty: defineProperty
});
